<template>
  <div class="col-xs-4 col-sm-1-and-a-half quick-order-variant">
    <template v-if="blankVariant">
      {{ variant.name }} &ndash; {{ variant.display_price }}
      <input
        type="number"
        min="0"
        :max="max"
        :value="quantity"
        class="form-control"
        @change="setQuantity"
      />
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      variant: {
        type: Object,
        required: true
      },
      oneOzLimit: {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        quantity: null
      }
    },
    computed: {
      max() {
        if (this.variant.one_oz_fragrance) {
          return this.oneOzLimit
        }
        return null
      },
      blankVariant() {
        return !!this.variant.id;
      }
    },
    methods: {
      setQuantity(event) {
        this.quantity = event.target.value
        const quantityAdjusted = this.max && this.quantity > this.oneOzLimit
        if (quantityAdjusted) {
          this.quantity = this.oneOzLimit.toString()
        }
        this.$emit('change', {
          variantId: this.variant.id,
          quantity: this.quantity,
          quantityAdjusted
        })
      }
    }
  }
</script>

<style>
  .quick-order-variant input {
    width: 80px;
  }
</style>
